import { render, staticRenderFns } from "./adjustFreeBalance.vue?vue&type=template&id=9b7c774a&scoped=true&lang=pug"
import script from "./adjustFreeBalance.vue?vue&type=script&lang=js"
export * from "./adjustFreeBalance.vue?vue&type=script&lang=js"
import style0 from "./adjustFreeBalance.vue?vue&type=style&index=0&id=9b7c774a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7c774a",
  null
  
)

export default component.exports